import React from "react";
import MuiCreditCardIcon from "@mui/icons-material/CreditCard";
import VisaIcon from "@assets/icons/cards/visa.svg";
import MastercardIcon from "@assets/icons/cards/mastercard.svg";
import AmexIcon from "@assets/icons/cards/amex.svg";
import DiscoverIcon from "@assets/icons/cards/discover.svg";
import DinersClubIcon from "@assets/icons/cards/diners.svg";
import JcbIcon from "@assets/icons/cards/jcb.svg";
import EloIcon from "@assets/icons/cards/elo.svg";

type CreditCardBrand =
  | "visa"
  | "mastercard"
  | "amex"
  | "discover"
  | "dinersclub"
  | "jcb"
  | "elo"
  | string;

interface CreditCardIconProps {
  brand: CreditCardBrand;
  size?: number;
}

export const CreditCardIcon: React.FC<CreditCardIconProps> = ({
  brand,
  size = 32,
}) => {
  const iconMap: Record<CreditCardBrand, string> = {
    visa: VisaIcon,
    mastercard: MastercardIcon,
    amex: AmexIcon,
    discover: DiscoverIcon,
    dinersclub: DinersClubIcon,
    jcb: JcbIcon,
    elo: EloIcon,
  };

  const selectedIcon = iconMap[brand];

  if (!selectedIcon) {
    return (
      <>
        <MuiCreditCardIcon style={{ fontSize: size * 0.75 }} /> {brand}
      </>
    );
  }

  return <img src={selectedIcon} width={size} height={size} />;
};
